module.exports = __webpack_public_path__ + "img/why-save-bg.d91c14ce.png";